@if (loading) {
  <nz-spin nzSimple nzSize="large"></nz-spin>
}

@if (rubric) {
  <app-user-skill-level-form
    [rubric]="rubric"
    [skills]="skills"
    [userSkills]="userSkills"
    [selectedUserCognitoUuid]="selectedUserCognitoUuid"
    (onSubmit)="handleFormSubmit($event)"
  ></app-user-skill-level-form>
}
